
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import { mapState } from 'vuex'
export default {
name: 'app',
directives: {
TransferDom
},
components: {
Tabbar,
TabbarItem,
Loading,
Toast,
Spinner
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction,
openid: state => state.vux.openid,
showtabbar: state => state.vux.showtabbar,
toastdata: state => state.vux.toastdata
}),
},
data () {
return {
tabbarList: [
{
'icon': '../static/image/home.png',
'iconActive': '../static/image/home1.png',
'label': '商城',
'link': '/shop',
'selected': false
},{
'icon': '../static/image/shop.png',
'iconActive': '../static/image/shop1.png',
'label': '洗车卡',
'link': '/vcard/2',
'selected': false
},{
'icon': '../static/image/map.png',
'iconActive': '../static/image/map1.png',
'label': '门店',
'link': '/tmap',
'selected': false
},{
'icon': '../static/image/my.png',
'iconActive': '../static/image/my1.png',
'label': '我的',
'link': '/my_wash_card_list',
'selected': false
},
],
}
},
mounted: function (e) {
var path = this.$route.path
var self = this
const url = document.location.href

this.tabbarList.map(function(item, index){
if(url.indexOf(item.link) !=-1 ){
item.selected = true
}
console.log(url, item.link)
})
}

}



// WEBPACK FOOTER //
// ./src/App.vue